import { render, staticRenderFns } from "./deleteFunction.vue?vue&type=template&id=604fbb01&lang=pug&"
import script from "./deleteFunction.vue?vue&type=script&lang=js&"
export * from "./deleteFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports